import clsx from 'clsx'
import { useState } from 'react'

/* blocks */
import Link from '@/atoms/Link/Link'
import VideoModal from '@/atoms/Modal/VideoModal'

/* assets */
import { ReactComponent as PlayBtn } from 'public/assets/icons/overview/play-icon.svg'

interface Props {
  primaryHeadline: string
  subText: string
  primaryCta: StrapiLinkSharedComponent
  secondaryCta?: StrapiLinkSharedComponent | null
  heroVideo?: StrapiUploadFile | null
  showReelVideo?: StrapiUploadFile
}

function PageHero({
  primaryHeadline,
  subText,
  primaryCta,
  secondaryCta,
  heroVideo,
  showReelVideo
}: Props): JSX.Element {
  const [showVideoModal, setShowVideoModal] = useState(false)

  const handleVideoButtonClick = () => {
    setShowVideoModal(true)
  }

  return (
    <section className="text-white relative">
      <div className="font-heading text-left relative">
        <div
          className="block md:hidden absolute inset-0 w-full h-full"
          style={{
            background: 'linear-gradient(180deg, #6252FF 0%, #6B00FF 155.56%)'
          }}
        ></div>
        <video
          className="hidden md:block | absolute inset-0 w-full h-full object-cover"
          src={heroVideo?.attributes.url}
          autoPlay
          muted
          loop
        />
        <div className="container | grid grid-cols-1 md:grid-cols-12 gap-8 | py-10 md:py-18 relative z-10">
          <div className="md:col-span-5">
            {primaryHeadline ? (
              <h1
                className="title text-4xl lg:text-6xl font-semibold tracking-tight | mb-6 md:mb-7"
                dangerouslySetInnerHTML={{ __html: primaryHeadline }}
              />
            ) : null}
            {subText ? (
              <h2
                className="font-body text-lg lg:text-xl | mb-6 md:mb-7"
                dangerouslySetInnerHTML={{ __html: subText }}
              />
            ) : null}
            <button
              onClick={handleVideoButtonClick}
              className="text-xl md:text-xl text-gray-10 font-bold | mb-10"
            >
              <div className="flex items-center text-left gap-4">
                Watch the Pepper showreel
                <PlayBtn />
              </div>
            </button>
            {showVideoModal && (
              <VideoModal
                link={showReelVideo?.attributes.url ?? ''}
                handleClose={() => setShowVideoModal(false)}
              />
            )}
            <div className="font-body font-bold flex flex-col sm:flex-row justify-center md:justify-start gap-4 w-full mb-6">
              <Link
                href={primaryCta.href}
                className={clsx(
                  'new-btn-tertiary',
                  !secondaryCta?.href ? 'flex-grow max-w-[351px]' : ''
                )}
              >
                {primaryCta.title}
              </Link>
              {secondaryCta && (
                <Link href={secondaryCta.href} className="font-bold">
                  {secondaryCta.title}
                </Link>
              )}
            </div>
          </div>
        </div>
      </div>
    </section>
  )
}

export default PageHero
